import I18n from '~/utils/i18n';

import { IGX6000Sensor } from './model';

export default (self: IGX6000Sensor) => ({
  get measurementsValueLabelPairs() {
    const options = self.configuration.optional_measurements?.map(({ unit, name }) => {
      const label = `${name}, ${unit}`;
      return { value: label, label };
    });
    return [{ label: I18n.t('base.labels.disabled'), value: null }, ...options];
  }
});
